"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var TopCarousel = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(TopCarousel, _window$AbstractView);

    var _super = _createSuper(TopCarousel);

    function TopCarousel(id, options) {
      var _thisSuper, _this;

      _classCallCheck(this, TopCarousel);

      var OPTIONS_DEFAULT = {
        scrollWatcher: true,
        autoPlay: true,
        autoPlayFrequence: 5000,
        pauseAutoPlayOnHover: window.Detectizr.device.type == "desktop",
        scrollParallax: true
      };
      options = $.extend(true, OPTIONS_DEFAULT, _.clone(options));
      _this = _super.call(this, id, options);
      _this.$cells = _this.$domElement.find(".carousel > .carousel-cell");
      _this.$flickityCarousel = _this.$domElement.find(".carousel").flickity({
        autoPlay: _this.$cells.length > 1 && _this.options.autoPlay ? _this.options.autoPlayFrequence : false,
        pauseAutoPlayOnHover: _this.options.pauseAutoPlayOnHover,
        setGallerySize: false,
        prevNextButtons: false,
        pageDots: _this.$cells.length > 1 ? true : false,
        draggable: '>1',
        wrapAround: true
      });
      _this.flickityCarouselData = _this.$flickityCarousel.data('flickity');

      _this.$domElement.find(".slide").each(function (i, el) {
        var slide = new window.AbstractSlide(_this.id + "_slide_" + i, {
          $domElement: $(el),
          // rootMargin "horizontal -1px" is needed by Flickity carousel px approssimations
          scrollWatcher: $(el).find("video").length ? {
            rootMargin: "0px -1px 0px -1px"
          } : false,
          onPointerEnter: function onPointerEnter() {
            this.$mediaWrapper.attr("data-frontdrop", "0.4");
            window.TweenMax.to(this.$media, 1, {
              force3D: "auto",
              transformOrigin: "center",
              scale: 1.08,
              ease: window.Cubic.easeInOut
            });
          },
          onPointerLeave: function onPointerLeave() {
            this.$mediaWrapper.attr("data-frontdrop", "0");
            window.TweenMax.to(this.$media, 1, {
              force3D: "auto",
              transformOrigin: "center",
              scale: 1,
              ease: window.Cubic.easeOut
            });
          },
          slideFX: null
        });

        _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(TopCarousel.prototype)), "addModules", _thisSuper).call(_thisSuper, slide);
      });

      if (_this.$cells.find(".media-wrapper").length) {
        TweenMax.set(_this.$cells.find(".media-wrapper"), {
          y: 0,
          clearProps: "all"
        });
      }

      return _this;
    }

    _createClass(TopCarousel, [{
      key: "init",
      value: function init() {
        if (this.options.scrollParallax) {
          this.SMcontroller = new ScrollMagic.Controller({
            loglevel: 0,
            vertical: true
          });
          var SCENE_OFFSET = $("html").hasClass("expanded-header") ? $(".site-header").outerHeight() : -$(".site-header").outerHeight();
          this.SMscene = new window.ScrollMagic.Scene({
            triggerElement: this.$domElement.get(0),
            triggerHook: "onLeave",
            duration: "100%",
            reverse: true,
            offset: SCENE_OFFSET
          });
          var timeline = new window.TimelineMax();
          timeline.to(this.$cells.find(".media-wrapper"), 1, {
            force3D: "auto",
            yPercent: "70%",
            ease: window.Linear.easeNone
          });
          this.SMscene.setTween(timeline);
          this.SMcontroller.addScene([this.SMscene]);
        }

        _get(_getPrototypeOf(TopCarousel.prototype), "init", this).call(this);
      }
    }, {
      key: "hasFullyExitViewport",
      value: function hasFullyExitViewport() {
        if (this.options.autoPlay) {
          this.$flickityCarousel.flickity('pausePlayer');
        }
      }
    }, {
      key: "isInViewport",
      value: function isInViewport() {
        if (this.options.autoPlay) {
          this.$flickityCarousel.flickity('unpausePlayer');
        }
      }
    }, {
      key: "dispose",
      value: function dispose() {
        if (this.SMcontroller) {
          this.SMcontroller.destroy();
          this.SMcontroller = null;
        }

        if (this.SMscene) {
          this.SMscene.destroy();
          this.SMscene = null;
        }

        TweenMax.set(this.$cells.find(".media-wrapper"), {
          y: 0,
          clearProps: "all"
        }); // dispose this before flickity

        _get(_getPrototypeOf(TopCarousel.prototype), "dispose", this).call(this);

        this.$flickityCarousel.off("settle.flickity").flickity("destroy");
        this.$flickityCarousel = null;
      }
    }]);

    return TopCarousel;
  }(window.AbstractView);

  window.TopCarousel = TopCarousel;
})(window);
